import AsyncStorage from '@react-native-async-storage/async-storage';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

/**
 * Storage key for the sales-rep confidential-field visibility toggle.
 */
export const CONFIDENTIAL_FIELD_VISIBILITY_STORAGE_KEY =
  '@confidential_field_visibility';

interface OrderEntryConfidentialVisibilityState {
  /** Whether confidential sales-rep data (GP%, GP$, item cost, etc.) is currently visible. */
  showConfidentialFields: boolean;
}

interface OrderEntryConfidentialVisibilityActions {
  /** Flips {@link OrderEntryConfidentialVisibilityState.showConfidentialFields}. */
  toggleConfidentialFieldDisplay: () => void;
}

type OrderEntryConfidentialVisibilityStore =
  OrderEntryConfidentialVisibilityState &
    OrderEntryConfidentialVisibilityActions;

/**
 * Persisted store that controls whether confidential sales-rep fields
 * (e.g., gross profit, item cost, and dynamic columns flagged `is_confidential`)
 * are visible. Persisted via `AsyncStorage` so the preference survives
 * page refreshes and app restarts.
 */
export const useConfidentialVisibilityStore =
  create<OrderEntryConfidentialVisibilityStore>()(
    persist(
      (set) => ({
        showConfidentialFields: true,
        toggleConfidentialFieldDisplay: () =>
          set((state) => ({
            showConfidentialFields: !state.showConfidentialFields,
          })),
      }),
      {
        name: CONFIDENTIAL_FIELD_VISIBILITY_STORAGE_KEY,
        storage: createJSONStorage(() => AsyncStorage),
      },
    ),
  );
